import { render, staticRenderFns } from "./SettingListModal.vue?vue&type=template&id=08764326&scoped=true"
import script from "./SettingListModal.vue?vue&type=script&lang=js"
export * from "./SettingListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08764326",
  null
  
)

export default component.exports